import React, { createContext, useContext } from 'react';
import useAuthManager from '../hooks/useAuthManager'; // Importa el hook

// Crear el contexto
const AuthContext = createContext(null);

// Hook personalizado para usar el contexto de autenticación de forma sencilla
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser utilizado dentro de un AuthProvider');
  }
  return context;
};

// Proveedor del contexto de autenticación
export const AuthProvider = ({ children }) => {
  // Instanciar el hook UNA SOLA VEZ aquí
  const auth = useAuthManager();

  // El valor del contexto es el objeto completo devuelto por el hook
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

// Puedes exportar AuthContext directamente si lo necesitas en algún lugar,
// pero generalmente usar useAuth es suficiente.
// export default AuthContext;